"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const mobx_react_lite_1 = require("mobx-react-lite");
const react_1 = tslib_1.__importStar(require("react"));
const silence_background_1 = require("../../../../store/encoder/silence-background");
const context_1 = require("../../../context");
const styling_1 = require("../../../styling");
const PlayerOverlayButton_1 = tslib_1.__importDefault(require("../../../ui-lib/PlayerOverlayButton"));
const VideoWrapper_1 = tslib_1.__importDefault(require("../../../ui-lib/VideoWrapper"));
const styles_1 = require("../../../ui-lib/VideoWrapper/styles");
const ErrorBoundary_1 = require("../../ErrorBoundary");
const TempVideo_1 = require("./TempVideo");
const ModularVideo = (0, mobx_react_lite_1.observer)(({ classes, backgroundAudio, ...props }) => {
    var _a;
    const ctx = (0, react_1.useContext)(context_1.EncoderUiContext);
    (0, ErrorBoundary_1.useUndefinedStoreError)((ctx === null || ctx === void 0 ? void 0 : ctx.videoElement) != null, "<EncoderVideo/>");
    const styling = (0, styles_1.videoWrapperStyles)({
        pillarBox: (_a = props.pillarBox) !== null && _a !== void 0 ? _a : false,
        fullScreen: props.isFullScreen,
        mirror: props.mirror,
        elementBlur: props.elementBlur,
        blurPixels: props.blurPixels,
    });
    const mergedClasses = (0, styling_1.useStyles)({ source: classes !== null && classes !== void 0 ? classes : {}, target: styling }, "videoWrapper");
    const mediaStream = backgroundAudio && !ctx.testMic
        ? (0, silence_background_1.withSilenceBackground)(ctx.audioCtx, ctx.mediaStreamController.source)
        : ctx.mediaStreamController.source;
    return (react_1.default.createElement(VideoWrapper_1.default, { classes: classes, isFullScreen: ctx.isFullscreen, ref: ctx.videoWrapperElement, ...props },
        react_1.default.createElement(TempVideo_1.TempVideo, { muted: !ctx.testMic, ref: ctx.videoElement, playsInline: true, source: mediaStream, className: mergedClasses.videoElement })));
});
const EncoderVideoWithErrorBoundary = ({ classes, ...props }) => {
    var _a;
    const styling = (0, styles_1.videoWrapperStyles)({
        pillarBox: (_a = props.pillarBox) !== null && _a !== void 0 ? _a : false,
        fullScreen: props.isFullScreen,
        mirror: props.mirror,
        elementBlur: props.elementBlur,
        blurPixels: props.blurPixels,
    });
    const mergedClasses = (0, styling_1.useStyles)({ source: classes !== null && classes !== void 0 ? classes : {}, target: styling }, "videoWrapper");
    return (
    /**
     * @todo: Temporary fallback. Update for a real fallback.
     */
    react_1.default.createElement(ErrorBoundary_1.ErrorBoundary, { render: () => (react_1.default.createElement(VideoWrapper_1.default, { classes: classes, ...props },
            react_1.default.createElement("div", { className: mergedClasses.videoElement, style: { display: "inline-block", aspectRatio: "16/9" } },
                react_1.default.createElement("p", null, "Video is not working"),
                react_1.default.createElement(PlayerOverlayButton_1.default, { classes: classes === null || classes === void 0 ? void 0 : classes.playerOverlayButton, ...props, disabled: true })))) },
        react_1.default.createElement(ModularVideo, { classes: classes, ...props })));
};
exports.default = EncoderVideoWithErrorBoundary;
//# sourceMappingURL=EncoderVideo.js.map